import type { StatusDef, StatusId } from "../sim/types";

function def(partial: StatusDef): StatusDef {
  return partial;
}

export const STATUSES: Record<StatusId, StatusDef> = {
  bleeding: def({
    id: "bleeding",
    name: "Bleeding",
    polarity: "condition",
    pip: "B",
    color: "#c0392b",
    stack: "refresh",
    tickEvery: 2,
    tickDamage: 1,
    tickHeal: 0,
    tickType: "bleed",
    tags: ["dot"],
  }),
  cripple: def({
    id: "cripple",
    name: "Cripple",
    polarity: "condition",
    pip: "C",
    color: "#d4a017",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["movement"],
  }),
  stagger: def({
    id: "stagger",
    name: "Stagger",
    polarity: "condition",
    pip: "S",
    color: "#f0c060",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["lock", "interrupt"],
  }),
  stun: def({
    id: "stun",
    name: "Stun",
    polarity: "condition",
    pip: "U",
    color: "#f5e6a8",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["lock", "interrupt", "immobile"],
  }),
  maim: def({
    id: "maim",
    name: "Maim",
    polarity: "condition",
    pip: "M",
    color: "#8e2c2c",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["offense"],
  }),
  wound: def({
    id: "wound",
    name: "Wound",
    polarity: "condition",
    pip: "W",
    color: "#6b1c1c",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["heal"],
  }),
  poison: def({
    id: "poison",
    name: "Poison",
    polarity: "condition",
    pip: "P",
    color: "#6bbf3a",
    stack: "refresh",
    tickEvery: 2,
    tickDamage: 1,
    tickHeal: 0,
    tickType: "poison",
    tags: ["dot"],
  }),
  burning: def({
    id: "burning",
    name: "Burning",
    polarity: "condition",
    pip: "F",
    color: "#e67e22",
    stack: "refresh",
    tickEvery: 1.5,
    tickDamage: 1,
    tickHeal: 0,
    tickType: "burning",
    tags: ["dot"],
  }),
  regen: def({
    id: "regen",
    name: "Regen",
    polarity: "enchantment",
    pip: "+",
    color: "#88e088",
    stack: "refresh",
    tickEvery: 2,
    tickDamage: 0,
    tickHeal: 1,
    tickType: "physical",
    tags: ["hot"],
  }),
  ire: def({
    id: "ire",
    name: "Ire",
    polarity: "condition",
    pip: "I",
    color: "#c0398b",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["mark"],
  }),
  curse: def({
    id: "curse",
    name: "Curse",
    polarity: "condition",
    pip: "K",
    color: "#6c3483",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "psychic",
    tags: ["hex"],
  }),
  blind: def({
    id: "blind",
    name: "Blind",
    polarity: "condition",
    pip: "X",
    color: "#bbb",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["vision"],
  }),
  silence: def({
    id: "silence",
    name: "Silence",
    polarity: "condition",
    pip: "Q",
    color: "#7f8c9a",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["cast"],
  }),
  fleet: def({
    id: "fleet",
    name: "Fleet",
    polarity: "enchantment",
    pip: ">",
    color: "#7ec8ff",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["movement"],
  }),
  frenzy: def({
    id: "frenzy",
    name: "Frenzy",
    polarity: "enchantment",
    pip: "!",
    color: "#ff8a4a",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["offense"],
  }),
  invisible: def({
    id: "invisible",
    name: "Invisibility",
    polarity: "enchantment",
    pip: "O",
    color: "#9aa4b2",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["vision"],
  }),
  empathy: def({
    id: "empathy",
    name: "Empathy",
    polarity: "condition",
    pip: "E",
    color: "#9b7ed9",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "psychic",
    tags: ["hex"],
  }),
  retribution: def({
    id: "retribution",
    name: "Retribution",
    polarity: "condition",
    pip: "R",
    color: "#e8b84a",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["mark"],
  }),
  spirit_arms: def({
    id: "spirit_arms",
    name: "Spirit Arms",
    polarity: "enchantment",
    pip: "A",
    color: "#6bb8c8",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["buff"],
  }),
  mystic_sweep: def({
    id: "mystic_sweep",
    name: "Mystic Sweep",
    polarity: "enchantment",
    pip: "Y",
    color: "#d4c06a",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["buff"],
  }),
  avatar: def({
    id: "avatar",
    name: "Avatar",
    polarity: "enchantment",
    pip: "V",
    color: "#f2e6c4",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["buff"],
  }),
  sanctuary: def({
    id: "sanctuary",
    name: "Sanctuary",
    polarity: "enchantment",
    pip: "H",
    color: "#c9b37a",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["buff"],
  }),
  rally: def({
    id: "rally",
    name: "Rally",
    polarity: "enchantment",
    pip: "L",
    color: "#e8b84a",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["buff"],
  }),
  tide: def({
    id: "tide",
    name: "Turn the Tide",
    polarity: "enchantment",
    pip: "T",
    color: "#f0d080",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["buff"],
  }),
  warded: def({
    id: "warded",
    name: "Warded",
    polarity: "enchantment",
    pip: "D",
    color: "#b8a0e0",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "psychic",
    tags: ["immune"],
  }),
  faith: def({
    id: "faith",
    name: "Shield of Faith",
    polarity: "enchantment",
    pip: "*",
    color: "#f0e2a8",
    stack: "refresh",
    tickEvery: 0,
    tickDamage: 0,
    tickHeal: 0,
    tickType: "physical",
    tags: ["buff"],
  }),
};

export function statusDef(id: StatusId): StatusDef {
  return STATUSES[id];
}
